import { useState, useEffect } from "react";
import { Card, Col, Row, Button, Table, Form, Modal } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../utils/constant";
import ExpenseStatusModal from "../../components/Modals/CustomerExpenseModal";
import TechExpenditure from "../../pages/TechExpenditure";
import { BsDownload } from "react-icons/bs";
import Loader from "../../components/Loader";
import NoData from "../../components/NoData";
import ExportModal from "../../components/Modals/ExportsModel/main";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import { useCommonContext } from "../../utils/context";

import EpendiureViewModal from "../../components/Modals/HisstoryModals/ExpenditureViewModel";
import { FaUserCircle } from "react-icons/fa";
import Pagination from "../../components/Pagination";
import StatusBadge from "../../components/StatusBadge";
const Expenditure = () => {
  const [loading, setLoading] = useState(false);
  const [eloading, setELoading] = useState(false);
  const [technicians, setTechnicians] = useState([]);
  const [selectedTechId, setSelectedTechId] = useState(null);
  const [expenses, setExpenses] = useState([]);
  const [showAddExpenseModal, setShowAddExpenseModal] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [showExportModal, setShowExportModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [showViewModal, setShowViewModal] = useState(false);
  const [showExpenseTypeModal, setShowExpenseTypeModal] = useState(false);
  const [expenseTypes, setExpenseTypes] = useState([]);
  const [categoryInputs, setCategoryInputs] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const userPermissions = localStorage.getItem("user_permissions");
  const role = localStorage.getItem("role");

  useEffect(() => {
    fetchTechnicians();
  }, [role, searchText]);

  useEffect(() => {
    if (selectedTechId) {
      fetchExpenses(selectedTechId, currentPage);
    }
  }, [selectedTechId, itemsPerPage, currentPage]);

  useEffect(() => {
    fetchExpenseTypes();
  }, []);

  const fetchExpenseTypes = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/expense-type/`, {
        headers: HEADERS,
      });
      if (response) {
        setExpenseTypes(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching expense types:", error);
    }
  };

  const fetchTechnicians = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/users/tms_users/?role=technician&role=sales&page_size=all`,
        {
          headers: {
            ...HEADERS,
            "Content-Type": "application/json",
          },
          params: {
            search: searchText || undefined,
          },
        }
      );
      if (response.data && response.data.results) {
        setTechnicians(response.data.results);
      }
    } catch (error) {
      // toast.error("Failed to fetch technicians. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchExpenses = async (techId, page = 1) => {
    setELoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/expenses/?technician=${techId}`,
        {
          headers: {
            ...HEADERS,
            "Content-Type": "application/json",
          },
          params: {
            page: page,
            page_size: itemsPerPage,
          },
        }
      );
      if (response.data) {
        let expenses = response?.data?.results || [];
        setExpenses(expenses);
        setTotalPages(Math.ceil(response.data.total_pages));
        setCurrentPage(page);
        setELoading(false);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setCurrentPage(1);
        fetchExpenses(1);
      } else {
        // toast.error(`Error fetching FSRs: ${error.message}`);
      }
    } finally {
      setELoading(false);
    }
  };

  const handlePageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleFileDownload = async (fileUrl, fileName) => {
    try {
      const response = await fetch(`${BASE_URL}/api/image_download/`, {
        method: "POST",
        headers: {
          ...HEADERS,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ fileUrl, fileName }),
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const handleUpdateStatusClick = (expense) => {
    setSelectedExpense(expense);
    setShowAddExpenseModal(true);
  };

  const handleModalClose = () => {
    setShowAddExpenseModal(false);
    setSelectedExpense(null);
  };

  const handleViewExpenditure = (expense) => {
    setSelectedExpense(expense);
    setShowViewModal(true);
  };

  const handleAddCategoryInput = () => {
    setCategoryInputs([...categoryInputs, ""]);
  };

  const handleChangeCategoryInput = (index, value) => {
    const updatedInputs = [...categoryInputs];
    updatedInputs[index] = value;
    setCategoryInputs(updatedInputs);
  };

  const handleRemoveCategoryInput = (index) => {
    const updatedInputs = [...categoryInputs];
    updatedInputs.splice(index, 1);
    setCategoryInputs(updatedInputs);
  };

  const handleAddCategory = async () => {
    try {
      if (categoryInputs.some((input) => input.trim() === "")) {
        toast.error("Please fill all the fields before saving.");
        return;
      }

      const addPromises = categoryInputs.map((category) =>
        axios.post(
          `${BASE_URL}/api/expense-type/`,
          { name: category },
          { headers: HEADERS }
        )
      );

      const responses = await Promise.all(addPromises);

      if (responses.length > 0) {
        toast.success("All expense types added successfully.");
      }

      fetchExpenseTypes();
      setCategoryInputs([]);
      setEditIndex(null);
      setShowExpenseTypeModal(false);
    } catch (error) {
      console.error("Error adding/updating category:", error);
      toast.error(
        error.response?.data?.message || "An error occurred. Please try again."
      );
    }
  };

  const handleUpdateCategory = async () => {
    try {
      if (editIndex !== null) {
        const { id, name } = expenseTypes[editIndex];
        const response = await axios.put(
          `${BASE_URL}/api/expense-type/${id}/`,
          { name },
          { headers: HEADERS }
        );

        if (response) {
          toast.success(
            response.data.message || "Expense Types updated successfully."
          );
        }
      }

      fetchExpenseTypes();
      setCategoryInputs([]);
      setEditIndex(null);
    } catch (error) {
      console.error("Error adding/updating category:", error);
      toast.error(
        error.response?.data?.message || "An error occurred. Please try again."
      );
    }
  };

  const handleRemoveCategory = async (index) => {
    try {
      const categoryId = expenseTypes[index].id;
      const response = await axios.delete(
        `${BASE_URL}/api/expense-type/${categoryId}/`,
        {
          headers: HEADERS,
        }
      );
      fetchExpenseTypes();
      toast.success(response.data.message);
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  return (
    <div className="container-fluid ">
      <Row className="mt-3">
        <Col xs={12} sm={6} lg={3} className="mb-3">
          <Card className="w-100  border-0 rounded-lg">
            <Card.Header className="bg-primary text-white border-bottom-0 rounded-top">
              <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                <span className="fs-5 fw-semibold mb-2 mb-sm-0 me-4">
                  Users
                </span>
                <input
                  type="text"
                  className="form-control w-100 w-sm-auto"
                  value={searchText}
                  placeholder="Search Here..."
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </Card.Header>

            <Card.Body
              className="overflow-auto"
              style={{
                maxHeight: "700px",
                cursor: "pointer",
                backgroundColor: "#fff",
              }}
            >
              {loading ? (
                <Loader />
              ) : technicians.length > 0 ? (
                technicians.map((tech) => (
                  <Card
                    key={tech.id}
                    className={`user-item mb-3 border-0 shadow-sm p-2 rounded-3 
        d-flex  justify-content-between
        ${
          selectedTechId === tech.id
            ? "border  border-primary bg-primary bg-opacity-10 text-primary shadow-sm"
            : "bg-white text-dark"
        } 
        transition-all`}
                    onClick={() => setSelectedTechId(tech.id)}
                    style={{
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                  >
                    <Card.Body className="d-flex  gap-3 p-2">
                      <div className="flex-shrink-0">
                        {tech.profile_image ? (
                          <img
                            src={tech.profile_image}
                            alt="Profile"
                            className="rounded-circle border"
                            style={{
                              width: "35px",
                              height: "35px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <FaUserCircle size={35} className="text-secondary" />
                        )}
                      </div>
                      <div className="flex-grow-1 overflow-hidden">
                        <h6
                          className="mb-0  text-truncate"
                          style={{ maxWidth: "130px" }}
                          title={`${tech.first_name} ${tech.last_name}`}
                        >
                          {tech.first_name} {tech.last_name}
                        </h6>
                        <small
                          className="text-muted d-block text-truncate"
                          style={{ maxWidth: "130px" }}
                        >
                          {tech.role}
                        </small>
                      </div>
                      <span
                        className="badge d-flex align-items-center justify-content-center 
             bg-secondary text-white flex-shrink-0"
                        style={{
                          minWidth: "40px",
                          height: "25px",
                          fontSize: "14px",
                          borderRadius: "12px",
                        }}
                      >
                        {tech.id}
                      </span>
                    </Card.Body>
                  </Card>
                ))
              ) : (
                <NoData message="No Data Found" height="400px" />
              )}
            </Card.Body>
          </Card>
        </Col>
        <Modal
          show={showExpenseTypeModal}
          onHide={() => {
            setShowExpenseTypeModal(false);
            setCategoryInputs([]);
            setEditIndex(null);
          }}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Manage Expense Types</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex justify-content-between align-items-center mb-3">
              {userPermissions.includes("expencetype_add_expencetype") && (
                <Button
                  variant="primary"
                  onClick={handleAddCategoryInput}
                  className="btn-sm d-flex align-items-center"
                >
                  + Add Expense Type
                </Button>
              )}
            </div>

            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "4px",
                borderRadius: "8px",
              }}
            >
              {categoryInputs.map((category, index) => (
                <div key={index} className="mb-2 d-flex align-items-center">
                  <Form.Control
                    type="text"
                    value={category}
                    onChange={(e) =>
                      handleChangeCategoryInput(index, e.target.value)
                    }
                    placeholder="Expense Type"
                    required
                    className="me-2"
                  />
                  <i
                    className="fas fa-times text-danger cursor-pointer"
                    onClick={() => handleRemoveCategoryInput(index)}
                    style={{ fontSize: "16px" }}
                  ></i>
                </div>
              ))}
            </div>

            <div
              style={{
                maxHeight: "200px",
                overflowY: "auto",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px",
                padding: "10px",
              }}
              className="scrollbar-sm"
            >
              {expenseTypes.length > 0 ? (
                expenseTypes.map((expense, index) => (
                  <div
                    key={index}
                    className="mb-2 d-flex align-items-center justify-content-between"
                  >
                    {editIndex === index ? (
                      <Form.Control
                        type="text"
                        value={expense.name}
                        onChange={(e) =>
                          setExpenseTypes((prev) =>
                            prev.map((item, i) =>
                              i === index
                                ? { ...item, name: e.target.value }
                                : item
                            )
                          )
                        }
                        className="me-2"
                      />
                    ) : (
                      <span className="truncate-text" title={expense.name}>
                        {expense.name}
                      </span>
                    )}
                    <div>
                      {userPermissions.includes(
                        "expencetype_change_expencetype"
                      ) &&
                        (editIndex === index ? (
                          <i
                            className="fas fa-check text-success me-2 cursor-pointer"
                            onClick={() => {
                              handleUpdateCategory(index);
                              setEditIndex(null);
                            }}
                            style={{ fontSize: "16px" }}
                          ></i>
                        ) : (
                          <i
                            className="fas fa-edit text-primary me-2 cursor-pointer"
                            onClick={() => setEditIndex(index)}
                            style={{ fontSize: "16px" }}
                          ></i>
                        ))}

                      {userPermissions.includes(
                        "expencetype_delete_expencetype"
                      ) && (
                        <i
                          className="fas fa-trash-alt text-danger cursor-pointer"
                          onClick={() => handleRemoveCategory(index)}
                          style={{ fontSize: "16px" }}
                        ></i>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-muted text-center">
                  No expense types available.
                </p>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowExpenseTypeModal(false);
                setCategoryInputs([]);
                setEditIndex(null);
              }}
            >
              Close
            </Button>
            <Button variant="primary" onClick={handleAddCategory}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>

        <Col md={9}>
          <Card className="">
            <Card.Header className="bg-primary text-white d-flex flex-column flex-sm-row justify-content-between align-items-start align-sm-items-center">
              <span className="fs-5 fw-semibold mb-2 mb-sm-0 me-sm-4">
                Expenditure
              </span>

              <div className="d-flex flex-column flex-sm-row gap-2 w-100 w-sm-auto">
                {userPermissions.includes("expencetype_view_expencetype") && (
                  <Button
                    variant="primary"
                    onClick={() => setShowExpenseTypeModal(true)}
                    className="fw-bold w-100 w-sm-auto"
                  >
                    Manage Expense Types
                  </Button>
                )}
                {(userPermissions.includes("expenses_can_export_all") ||
                  userPermissions.includes("expenses_export")) && (
                  <Button
                    className="text-white fw-bold w-100 w-sm-auto"
                    onClick={() => setShowExportModal(true)}
                    disabled={!selectedTechId}
                  >
                    Export <BsDownload className="fw-bold" />
                  </Button>
                )}
              </div>
            </Card.Header>

            <Card.Body>
              <div
                className={`table-responsive ${
                  expenses.length === 0 ? "" : "tabell"
                } `}
                style={{ height: "70vh" }}
              >
                {!selectedTechId ? (
                  <div className="text-center text-muted">
                    Select a user to see expenses
                  </div>
                ) : eloading ? (
                  <Loader />
                ) : (
                  <>
                    {expenses.length > 0 ? (
                      <table className="table   tstart">
                        <thead className="thead">
                          <tr style={{ whiteSpace: "nowrap" }}>
                            <th style={{ width: "150px" }}>Expense ID</th>
                            <th style={{ width: "150px" }}>Ticket ID</th>
                            <th style={{ width: "200px" }}>Date</th>
                            <th style={{ width: "300px" }}>Expense Type</th>
                            <th style={{ width: "300px" }}>From</th>
                            <th style={{ width: "300px" }}>To</th>
                            <th style={{ width: "200px" }}>Expense Date</th>
                            <th style={{ width: "150px" }}>Amount</th>
                            <th style={{ width: "250px" }}>Approved Amount</th>
                            <th style={{ width: "400px" }}>Description</th>
                            <th style={{ width: "200px" }}>Status</th>
                            <th style={{ width: "400px" }}>Remark</th>
                            <th style={{ width: "600px" }}>Image</th>
                            <th style={{ width: "200px" }}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {expenses.map((expense, index) => (
                            <tr
                              key={expense.id}
                              className="tbody"
                              onClick={() => handleViewExpenditure(expense)}
                            >
                              <td>
                                <div title={expense.id} className="tdsubject">
                                  {expense.id || "—"}
                                </div>
                              </td>
                              <td>
                                <div
                                  title={expense.ticket?.id}
                                  className="tdsubject"
                                >
                                  {expense.ticket?.id || "—"}
                                </div>
                              </td>
                              <td>
                                <div
                                  title={expense.created_at}
                                  className="tdsubject"
                                >
                                  {expense.created_at || "—"}
                                </div>
                              </td>
                              <td>
                                <div
                                  title={expense.expense_type}
                                  className="tdsubject"
                                >
                                  {expense.expense_type || "—"}
                                </div>
                              </td>
                              <td>
                                <div
                                  title={expense.from_field}
                                  className="tdsubject"
                                >
                                  {expense.from_field || "—"}
                                </div>
                              </td>
                              <td>
                                <div title={expense.to} className="tdsubject">
                                  {expense.to || "—"}
                                </div>
                              </td>
                              <td>
                                <div
                                  title={expense.expense_date}
                                  className="tdsubject"
                                >
                                  {expense.expense_date || "—"}
                                </div>
                              </td>
                              <td>
                                <div
                                  title={expense.amount}
                                  className="tdsubject"
                                >
                                  {expense.amount || "—"}
                                </div>
                              </td>
                              <td>
                                <div
                                  title={expense.approvedAmount || "—"}
                                  className="tdsubject"
                                >
                                  {expense.approvedAmount || "—"}
                                </div>
                              </td>
                              <td>
                                <div
                                  title={expense.description || "—"}
                                  className="tdsubject"
                                >
                                  {expense.description || "—"}
                                </div>
                              </td>
                              <td>
                                <StatusBadge status={expense.status} />
                              </td>

                              <td>
                                <div
                                  title={
                                    expense.status === "Approved" &&
                                    expense.approvedRemark
                                      ? expense.approvedRemark
                                      : expense.status === "Rejected" &&
                                        expense.rejectedRemark
                                      ? expense.rejectedRemark
                                      : expense.status === "Paid" &&
                                        expense.paidRemark
                                      ? expense.paidRemark
                                      : "None"
                                  }
                                  className="tdsubject"
                                >
                                  {expense.status === "Approved" &&
                                  expense.approvedRemark
                                    ? expense.approvedRemark
                                    : expense.status === "Rejected" &&
                                      expense.rejectedRemark
                                    ? expense.rejectedRemark
                                    : expense.status === "Paid" &&
                                      expense.paidRemark
                                    ? expense.paidRemark
                                    : "None"}
                                </div>
                              </td>
                              <td>
                                <div
                                  title={
                                    expense.image
                                      ? expense.image.split("/").pop()
                                      : "No Image"
                                  }
                                  className="tdsubject d-flex align-items-center "
                                >
                                  {expense.image ? (
                                    <div className="d-flex align-items-center ">
                                      <span
                                        className="text-truncate"
                                        style={{ maxWidth: "120px" }}
                                      >
                                        {expense.image.split("/").pop()}
                                      </span>

                                      <Button
                                        variant="link"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleFileDownload(
                                            expense.image,
                                            expense.image.split("/").pop()
                                          );
                                        }}
                                        className="p-0"
                                      >
                                        <BsDownload
                                          size={14}
                                          className="text-primary"
                                        />
                                      </Button>
                                    </div>
                                  ) : (
                                    <span className="text-muted">No Image</span>
                                  )}
                                </div>
                              </td>

                              <td>
                                {userPermissions.includes(
                                  "expenses_update_status"
                                ) &&
                                  expense.status !== "Paid" &&
                                  expense.status !== "Rejected" && (
                                    <div
                                      title="Update Status"
                                      className="tdsubject"
                                    >
                                      <Button
                                        variant="primary"
                                        size="sm"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleUpdateStatusClick(expense);
                                        }}
                                      >
                                        Update Status
                                      </Button>
                                    </div>
                                  )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div
                        className="d-flex flex-column justify-content-center align-items-center"
                        style={{ height: "400px" }}
                      >
                        <p className="text-muted fs-4">No Expenses Found.</p>
                      </div>
                    )}
                  </>
                )}
              </div>
            </Card.Body>
            {expenses.length > 0 && (
              <Pagination
                // currentPage={currentPage}
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                handlePageClick={handlePageClick}
                handleItemsPerPageChange={handleItemsPerPageChange}
              />
            )}
          </Card>
        </Col>
      </Row>

      <ExportModal
        show={showExportModal}
        handleClose={() => setShowExportModal(false)}
        title="expenses"
        technicianId={selectedTechId}
      />
      {selectedExpense && (
        <ExpenseStatusModal
          show={showAddExpenseModal}
          expenseData={selectedExpense}
          handleClose={handleModalClose}
          onAddExpense={() => fetchExpenses(selectedTechId, currentPage)}
        />
      )}

      <EpendiureViewModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        ependitureId={selectedExpense?.id}
        ependiture={selectedExpense}
      />
    </div>
  );
};

export default Expenditure;
